import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TestUser } from '../services/test-user-catalog.service';

@Component({
  selector: 'app-test-login-dialog',
  standalone: false,
  template: `
    <div mat-dialog-title>
      <h2>Test Mode - Select User</h2>
    </div>

    <div mat-dialog-content>
      <p>Choose a test user to login with:</p>

      <div class="user-selection">
        <button
          *ngFor="let user of testUsers"
          mat-raised-button
          [color]="getButtonColor(user.id)"
          class="user-button"
          (click)="selectUser(user)"
          [disabled]="loading"
          [class.selected]="currentUser?.id === user.id"
        >
          <mat-icon>{{ getButtonIcon(user.id) }}</mat-icon>
          {{ user.name }}
          <small>{{ user.description }}</small>
        </button>
      </div>

      <div *ngIf="loading" class="loading">
        <mat-spinner diameter="30"></mat-spinner>
        <p>Logging in...</p>
      </div>
    </div>

    <div mat-dialog-actions>
      <button mat-button (click)="onCancel()" [disabled]="loading">Cancel</button>
    </div>
  `,
  styles: [
    `
      .user-selection {
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin: 16px 0;
      }

      .user-button {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 16px;
        min-height: 80px;
        text-align: center;
      }

      .user-button.selected {
        border: 2px solid #1976d2;
      }

      .user-button mat-icon {
        margin-bottom: 8px;
        font-size: 32px;
        width: 32px;
        height: 32px;
      }

      .user-button small {
        display: block;
        margin-top: 4px;
        opacity: 0.7;
      }

      .loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 16px 0;
      }

      .loading p {
        margin-top: 8px;
      }
    `,
  ],
})
export class TestLoginDialogComponent {
  loading = false;
  testUsers: TestUser[] = [];
  currentUser: TestUser | null = null;

  constructor(
    public dialogRef: MatDialogRef<TestLoginDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.testUsers = data.testUsers || [];
    this.currentUser = data.currentUser || null;
  }

  getButtonColor(userId: string): string {
    switch (userId) {
      case 'admin':
        return 'primary';
      case 'writer':
        return 'accent';
      case 'reader':
        return 'warn';
      default:
        return 'primary';
    }
  }

  getButtonIcon(userId: string): string {
    switch (userId) {
      case 'admin':
        return 'admin_panel_settings';
      case 'writer':
        return 'edit';
      case 'reader':
        return 'visibility';
      default:
        return 'person';
    }
  }

  async selectUser(user: TestUser): Promise<void> {
    this.loading = true;

    try {
      // Close dialog with the selected user
      this.dialogRef.close({ success: true, user });
    } catch (error) {
      console.error('Error selecting test user:', error);
      this.loading = false;
    }
  }

  onCancel(): void {
    this.dialogRef.close({ success: false });
  }
}
